'use client'

import { StateCreator } from 'zustand'
import { type StoreState } from '.'

export type FavoriteTabKey = 'dashboard' | 'markets'

// Record<address, path> per tab key
type FavoriteTabsMap = Record<string, Record<string, string>>

export interface UserPreferences {
  favoriteTabs: FavoriteTabsMap
  setFavoriteTab: (key: FavoriteTabKey, address: string, path: string) => void
  clearFavoriteTab: (key: FavoriteTabKey, address: string) => void
  getFavoriteTab: (key: FavoriteTabKey, address: string | undefined) => string | undefined
}

export interface UserPreferencesSlice {
  userPreferences: UserPreferences
}

export const initUserPreferencesSlice: StateCreator<StoreState, [], [], UserPreferencesSlice> = (set, get) => ({
  userPreferences: {
    favoriteTabs: {},
    setFavoriteTab: (key: FavoriteTabKey, address: string, path: string) =>
      set((state) => ({
        userPreferences: {
          ...state.userPreferences,
          favoriteTabs: {
            ...state.userPreferences.favoriteTabs,
            [key]: {
              ...state.userPreferences.favoriteTabs[key],
              [address.toLowerCase()]: path,
            },
          },
        },
      })),
    clearFavoriteTab: (key: FavoriteTabKey, address: string) =>
      set((state) => {
        const { [address.toLowerCase()]: _, ...rest } = state.userPreferences.favoriteTabs[key] ?? {}
        return {
          userPreferences: {
            ...state.userPreferences,
            favoriteTabs: {
              ...state.userPreferences.favoriteTabs,
              [key]: rest,
            },
          },
        }
      }),
    getFavoriteTab: (key: FavoriteTabKey, address: string | undefined) => {
      if (!address) return undefined
      return get().userPreferences.favoriteTabs[key]?.[address.toLowerCase()]
    },
  },
})

export interface PersistedUserPreferencesSlice {
  userPreferences: {
    favoriteTabs: FavoriteTabsMap
  }
}

export function persistUserPreferencesSlice(state: StoreState): PersistedUserPreferencesSlice {
  return {
    userPreferences: {
      favoriteTabs: state.userPreferences.favoriteTabs,
    },
  }
}
